import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
export type GqlCompleteSccFieldsFragment = { kind: Types.GqlTransactionKind, decisionDate?: string | null, registrationDate?: string | null, name: string, changedNumberOfShares?: number | null, numberOfShares?: number | null, pricePerShare?: number | null, currency?: Types.GqlCurrency | null, changedNumberOfSharesSplitAdjusted?: number | null, numberOfSharesSplitAdjusted?: number | null, pricePerShareSplitAdjusted?: number | null, preMoney?: number | null, paidAmount?: number | null, postMoney?: number | null, foundersShareFraction?: number | null, shareCapitalBefore?: number | null, shareCapitalChanged?: number | null, shareCapitalAfter?: number | null, sharePriceFactor?: number | null, splitFactor?: number | null, sortOrder?: number | null, caseNumber?: string | null, filingYear: string, filingNumber: string, serialNumber: string, id: string, sccId: string };

export const CompleteSccFieldsFragmentDoc = gql`
    fragment CompleteSccFields on CompleteShareCapitalChange {
  kind
  decisionDate
  registrationDate
  name
  changedNumberOfShares
  numberOfShares
  pricePerShare
  currency
  changedNumberOfSharesSplitAdjusted
  numberOfSharesSplitAdjusted
  pricePerShareSplitAdjusted
  preMoney
  paidAmount
  postMoney
  foundersShareFraction
  shareCapitalBefore
  shareCapitalChanged
  shareCapitalAfter
  sharePriceFactor
  splitFactor
  sortOrder
  caseNumber
  filingYear
  filingNumber
  serialNumber
  id
  sccId
}
    `;